import React from 'react';
import { Helmet } from 'react-helmet-async';
// ✅ Import Helmet
import OrderPlacement from '../elementsui/OrderPlacement';

const OrderPlacementPage = () => {
  return (
    <div>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Place Your Order | binzal - Quick Grocery Checkout</title>
        <meta name="description" content="Review and confirm your delivery details before placing your grocery order with binzal – Bihar’s fastest delivery app." />
        <meta name="keywords" content="binzal order, place grocery order, Bihar delivery checkout, confirm purchase" />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Place Order | binzal" />
        <meta property="og:description" content="Final step before delivery! Place your order with binzal and enjoy fresh groceries at your doorstep." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <OrderPlacement />
    </div>
  );
};

export default OrderPlacementPage;
